import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActiveCycleEntityType, PassiveCycleEntityType } from '../models/commonEnums';

@Injectable({
  providedIn: 'root'
})

export class DocumentXMLService {

  constructor(private http: HttpClient) {
  }

  getPDFHTMLByDocumentId(id: number): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'json'
    }
    return this.http.get<any>(environment.apiFullUrl + '/DocumentXML/GetPDFHTMLByDocumentId/' + id, HTTPOptions).toPromise();
  }

  downloadXMLInvoices(documentIds: Array<number>): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'json'
    }
    return this.http.post<any>(environment.apiFullUrl + '/DocumentXML/DownloadXMLInvoices', documentIds, HTTPOptions).toPromise();
  }

  downloadPdfFromCustomXslt(documentIds: Array<number>): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'json'
    }
    return this.http.post<any>(environment.apiFullUrl + '/DocumentXML/DownloadPdfFromCustomXslt', documentIds, HTTPOptions).toPromise();
  }

  downloadXMLPassiveInvoice(id: number): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    return this.http.get<any>(environment.apiFullUrl + '/DocumentXML/DownloadXMLPassiveInvoice/' + id, HTTPOptions).toPromise();
  }

  downloadPdfPassiveFromCustomXslt(documentID: number, isPdf: boolean = false): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    return this.http.get<any>(environment.apiFullUrl + '/DocumentXML/GetPDFXSLTFromXMLBinary/' + documentID + '/' + isPdf, HTTPOptions).toPromise();
  }

  downloadPdfFromActiveCycle(id: number, activeCycleType: ActiveCycleEntityType) : Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    return this.http.get<any>(environment.apiFullUrl + '/DocumentXML/GetPDFXSLTFromActiveCicle/' + id + '/' + activeCycleType, HTTPOptions).toPromise();
  }

  downloadPdfFromPassiveCycle(id: number, passiveCycleType: PassiveCycleEntityType) : Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    return this.http.get<any>(environment.apiFullUrl + '/DocumentXML/GetPDFXSLTFromPassiveCicle/' + id + '/' + passiveCycleType, HTTPOptions).toPromise();
  }

  sendXmlInvoicesToPA(FK_Company: number, selectedDocumentsID: Array<number>): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    return this.http.post<any>(environment.apiFullUrl + "/DocumentXML/SendUBLToPA/" + FK_Company, selectedDocumentsID, HTTPOptions).toPromise();
  }

  sendXmlCDARToPA(documentsID: number, statusID: number, isPassive: boolean): Promise<any> {
    let HTTPOptions: Object = {
      responseType: 'blob'
    }
    if (isPassive == true) {
      return this.http.post<any>(environment.apiFullUrl + "/DocumentXML/SendSupplierCdarToPA/" + documentsID + "/" + statusID, HTTPOptions).toPromise();
    }
    else {
      return this.http.post<any>(environment.apiFullUrl + "/DocumentXML/SendCdarToPA/" + documentsID + "/" + statusID, HTTPOptions).toPromise();
    }
  }
}


